<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <circle cx="20" cy="20" r="20" fill="#E5FF83" />
    <path
      fill="#222325"
      d="M17.8 21.49l.827-2.715-2.175-1.677h2.706L20 14.39l.842 2.714h2.706l-2.19 1.677.827 2.715L20 19.8l-2.2 1.69Zm-3.3 8.74V23.07a7.9 7.9 0 0 1-1.475-2.29A8.1 8.1 0 0 1 12.5 18c0-2.09.727-3.87 2.181-5.32C16.136 11.23 17.91 10.5 20 10.5c2.09 0 3.865.73 5.32 2.18C26.77 14.13 27.5 15.91 27.5 18c0 .98-.175 1.91-.525 2.78a7.9 7.9 0 0 1-1.475 2.29v7.16L20 28.48l-5.5 1.75Zm5.5-6.23c1.667 0 3.083-.58 4.25-1.75C25.417 21.08 26 19.67 26 18s-.583-3.08-1.75-4.25C23.083 12.58 21.667 12 20 12s-3.083.58-4.25 1.75C14.583 14.92 14 16.33 14 18s.583 3.08 1.75 4.25C16.917 23.42 18.333 24 20 24Zm-4 4.03 4-1.07 4 1.07v-3.72a7.6 7.6 0 0 1-4.002.88 7.6 7.6 0 0 1-3.998-.88v3.72Z"
    />
  </svg>
</template>
<script>
export default {
  name: 'BudgetTypeRecognition',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 40
    },
    height: {
      type: [Number, String],
      required: false,
      default: 40
    }
  }
}
</script>
